import { Routes } from "@angular/router";
import { HowItWorksComponent } from "./how-it-works.component";
import { RewardsProgramComponent } from "./rewards-program/rewards-program.component";
import { ProduceProgramComponent } from "./produce-program/produce-program.component";
import { MainComponent } from "./main/main.component";
import {ProductTagsAndNavigationComponent} from "./product-tags-and-navigation/product-tags-and-navigation.component";

export const howItWorksRoutes: Routes = [
    {
        path: 'how-it-works',
        title: 'How it works',
        component: HowItWorksComponent,
        children: [
            {
                path: 'main',
                title: 'How it works',
                component: MainComponent
            },
            {
              path: 'product-tags-and-navigation',
              title: 'Product tags and navigation',
              component: ProductTagsAndNavigationComponent
            },
            {
                path: 'rewards-program',
                title: 'Roots rewards program',
                component: RewardsProgramComponent
            },
            {
                path: 'produce-program',
                title: 'Low cost produce program',
                component: ProduceProgramComponent
            },
        ]
    }
];
